import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Shell } from "@/components/Shell";
import Overview from "@/pages/Overview";
import Standardization from "@/pages/Standardization";
import Recommendations from "@/pages/Recommendations";
import Copilot from "@/pages/Copilot";
import DataPage from "@/pages/DataPage";
import Part360 from "@/pages/Part360";
import "@/App.css";

function App() {
  const [plant, setPlant] = useState("all");
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Shell plant={plant} setPlant={setPlant} />}>
          <Route path="/" element={<Overview plant={plant} />} />
          <Route path="/standardization" element={<Standardization plant={plant} />} />
          <Route path="/recommendations" element={<Recommendations plant={plant} />} />
          <Route path="/copilot" element={<Copilot plant={plant} />} />
          <Route path="/data" element={<DataPage plant={plant} />} />
          <Route path="/part/:id" element={<Part360Route />} />
        </Route>
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

const Part360Route = () => {
  const { id } = useParams();
  return <Part360 id={id} />;
};

export default App;
